export const iconFontAwesomeTextformattingTextWidth = (
	<i className="fa-solid fa-text-width"></i>
);
